import React from 'react'

import Collaborators from 'presentation/hospital/pages/Collaborators'

export default function makeHospitalCollaboratorsFactory() {
  return <Collaborators />
}
